import useFetcher from 'app/_utils/data/useFetcher';

import useSWRMutation from 'swr/mutation';

type DeleteOrganizationMembershipArguments = {
  organizationId: string;
};

export const useDeleteOrganizationMembership = (): ReturnType<
  typeof useSWRMutation<unknown, unknown, string, DeleteOrganizationMembershipArguments>
> => {
  const { fetcher } = useFetcher();

  return useSWRMutation(
    'DELETE_ORGANIZATION_MEMBERSHIP',
    (_, { arg }) =>
      fetcher(
        `${process.env.ZEUS_API_URL}/v1/system/memberships/${arg.organizationId}`,
        { method: 'DELETE' },
      ),
  );
};
